import { render, staticRenderFns } from "./PricingTypePage.vue?vue&type=template&id=79664184"
import script from "./PricingTypePage.vue?vue&type=script&lang=js"
export * from "./PricingTypePage.vue?vue&type=script&lang=js"
import style0 from "./PricingTypePage.vue?vue&type=style&index=0&id=79664184&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79664184')) {
      api.createRecord('79664184', component.options)
    } else {
      api.reload('79664184', component.options)
    }
    module.hot.accept("./PricingTypePage.vue?vue&type=template&id=79664184", function () {
      api.rerender('79664184', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/price/PricingTypePage.vue"
export default component.exports